<div class="tooltip-container" [id]="tooltipId">
    <div class="tooltip-title">{{title}}</div>
    <div class="tooltip-table">
        <div class="tooltip-table-row" *ngFor="let row of data|orderBy:'order':'asc'">
            <div class="tooltip-table-label">{{row.label}}</div>
            <div class="tooltip-table-value">{{row.value}}</div>
        </div>
    </div>
</div>
